<template>
  <v-dialog v-model="dialog"
            persistent
            max-width="600px">
    <v-form ref="form"
            :disabled="form.busy"
            @submit.prevent="submit">
      <v-card flat
              tile>
        <v-card-title>
          Add {{ contacts.length | pluralize('contact') }} to email list
        </v-card-title>
        <v-card-text>
          <v-combobox v-model="form.list"
                      label="Add a new list and hit enter, or select from existing lists"
                      outlined
                      clearable
                      :items="lists"
                      item-text="name"
                      :rules="[rules.required]"
                      :error-messages="form.errors.get('list')"
                      hint="If the contacts are already on the list, they will not be added again."
                      persistent-hint>
            <template v-slot:item="{item: list}">
              <div>
                {{ list.name }}
              </div>
              <v-spacer></v-spacer>
              <div>
                {{ list.subscriber_count }} active {{ list.subscriber_count | pluralize('subscriber', false) }}
              </div>
            </template>
          </v-combobox>
        </v-card-text>
        <v-card-actions>
          <v-btn type="submit"
                 @click.prevent="submit(false)"
                 :disabled="!form.list || form.busy"
                 color="primary">
            Add
          </v-btn>
          <v-btn type="submit"
                 @click.prevent="submit(true)"
                 :disabled="!form.list || form.busy">
            Add and send
          </v-btn>
          <v-btn @click.prevent="cancel">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import {mapGetters} from 'vuex';
import {Form} from 'vform';
import {isObject, isString, orderBy} from 'lodash';
import mailcoachService from '../../../services/mailcoachService';
import formValidation from '../../../plugins/formValidation';
import DOMPurify from 'dompurify';

export default {
  mixins: [formValidation],
  props: {
    contacts: {
      type: Array,
      required: true,
    },
    dialog: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      form: new Form({
        list: null,
      }),
      lists: [],
    }
  },
  computed: {
    ...mapGetters([
      'isAdmin',
      'isMember',
      'team',
      'user',
    ]),
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      mailcoachService.getLists({})
        .then(data => {
          this.lists = orderBy(data, ['name'], ['asc']);
        })
    },
    cancel() {
      this.$emit('dismiss')
    },
    addContacts(listID, send = false) {
      const form = new Form({
        contacts: this.contacts.map(c => c.id),
      });
      return this.form.post(`/api/mailcoach/lists/${listID}/contacts`, {data: form.data()})
        .then(response => {
          if (response.data.success) {
            this.$toast.success(DOMPurify.sanitize(response.data.message));
          } else {
            this.$toast.warning(DOMPurify.sanitize(response.data.message));
          }
          this.reset();
          this.$emit('dismiss');
          if (send) {
            this.$router.push({name: `${this.$root.routePrefix}.mailcoach.campaign.wizard`, query: {list_id: listID}})
          } else { // MLD-2668
            this.$router.push({name: `${this.$root.routePrefix}.mailcoach.list.edit`, params: {listID: listID}});
          }
        })
    },
    reset() {
      this.form.list = null;
      this.resetForm();
    },
    submit(send = false) {
      if (this.form.busy) {
        return;
      }
      if (isObject(this.form.list)) {
        return this.addContacts(this.form.list.id, send);
      } else if (isString(this.form.list)) {
        // Create a new Email List
        const form = new Form({
          name: this.form.list,
        })
        return form.post(`/api/mailcoach/lists`)
          .then(response => {
            return this.addContacts(response.data.id, send);
          })
          .catch(err => {
            this.$toast.error('Invalid list name.');
          })
      } else {
        this.$toast.error('form.list is not set');
      }
    }
  }
}
</script>
